// @ts-expect-error missing types
import * as PromptableInboxConnectOptInFlowContainer from 'InboxConnectUtils/components/PromptableInboxConnectOptInFlowContainer';
// @ts-expect-error missing types
import ConnectInbox from './lib/ConnectInbox';
// @ts-expect-error missing types
import { OUTLOOK_365_GCC_OAUTHOR_BASE } from './utils/Links';
import serviceTypes from './constants/serviceTypes';
const _outlookLegalPrompt = PromptableInboxConnectOptInFlowContainer.outlook;
class ConnectOutlook365GCCInbox extends ConnectInbox {
  constructor() {
    super(OUTLOOK_365_GCC_OAUTHOR_BASE, serviceTypes.outlookGccHigh, _outlookLegalPrompt);
  }
}
export default new ConnectOutlook365GCCInbox();